<div class="flex-column flex-middle">

    <!-- progressbar -->
    <ul class="progressbar col-1 pos-relative z-10 center m-r-2 w-12 m-t-6 m-b-10 p2">
        <li class="active cursor-pointer"><a routerLink="/basket"
               style="text-decoration: none;">{{'Bag' | translate}}</a></li>
        @for (step of visibleStepsSequence; track $index; let index = $index) {
        <li (click)="goTo(step)"
            class="cursor-pointer"
            [ngClass]="{'active' : ifDotActive(index), 'ng-hide' : step.name === 'deliveryOptions'}">{{step.stepTitle}}
        </li>
        }
    </ul>

    <form #form="ngForm"
          method="POST"
          class="checkout-form w-12">
        <!-- basket -->
        <div class="bg-col-w"
             zippyName="basketTab">

            <!-- 'basket' tab header -->
            <div class="cursor-pointer p-a-6 p-4-l-s p-4-r-s"
                 [zippyToggle]="['basketTab', 'basket']">
                <div>
                    <h4 class="s1 flex flex-middle"><i class="icon-basket fs-7 inline-flex"></i>
                        <span class="p-t-1 p-l-3">{{'Bag summary' | translate}}</span>
                    </h4>

                    <div class="flex flex-justify-between m-t-1 p-l-9">
                        <span class="p2 col-12">
                            {{'Order total (% items)' | translate : basket.qty}}
                            <price class="m-r-2 inline-block price"
                                   [precision]="2"
                                   [value]="basket.totals?.grand_total"></price>
                        </span>

                        <button type="button"
                                class="flex flex-middle p2 col-1 m-r-2">
                            <span [zippyName]="['basketTab', 'basket']"
                                  zippyClass="!ng-hide"><span>{{'Hide' | translate}}</span></span>
                            <span [zippyName]="['basketTab', 'basket']"
                                  class="!ng-hide"
                                  zippyClass="ng-hide">{{'Show' | translate}}</span>
                            <i [zippyName]="['basketTab', 'basket']"
                               zippyClass="is-open"
                               class="p-l-2 fs-2 inline-flex icon-arrow-down zippy-indicator"></i>
                        </button>
                    </div>
                </div>

                <!-- <span class="w-11 left col-12 p2 flex flex-row">
        <div class="w-1"></div>
        <div class="w-11 flex flex-justify-between flex-start">
          <span>Order total ({{basket.qty}} items):

            <price class="m-r-2 inline-block price"
              [precision]="2"
            [value]="basket.totals?.grand_total"></price>
          </span>

          <span class="flex flex-start p2">
            <span [zippyName]="['basketTab', 'basket']"
              class="ng-hide"
              zippyClass="!ng-hide"><a class="cursor-pointer"
            routerLink="/basket">Edit</a> | Hide</span>
            <span [zippyName]="['basketTab', 'basket']"
            zippyClass="ng-hide">Show</span>
            <i [zippyName]="['basketTab', 'basket']"
              zippyClass="is-open"
            class="p-l-1 p-t-1 fs-1 icon-arrow-down zippy-indicator"></i>
          </span>
        </div>
      </span> -->
            </div>

            <!-- content: basket -->
            <div class="hide-up-container checkout-minibasket-hide-up">
                <div class="ng-hide-animate hide-up"
                     [elementHeight]="'checkout-minibasket'"
                     [zippy]="['basketTab', 'basket']"
                     [zippyAuto]="true">
                    <checkout-minibasket />
                </div>
            </div>
        </div>
        <div class="m-t">
            <div class="hiddeExpressPayments"
                 *ifNotStandalone>
                <div class="bg-col-w p-a-6 p-4-l-s p-4-r-s ">
                    <h4 class="s1 flex flex-middle"><i class="icon-credit-cards fs-7 inline-flex"></i>
                        <span class="p-t-1 p-l-3">{{'Express checkout' | translate}}</span>
                    </h4>

                    <div class="m-t">
                        <div class="hiddeExpressPayments">
                            <stripe-express-payment-request-button
                                                                   class="block m-t-2"></stripe-express-payment-request-button>

                            <paypal-express-button class="block m-t-2 pos-relative z-0 m-b-1"></paypal-express-button>
                        </div>
                    </div>
                </div>
                <div class="_expressCheckoutDevider w-12 pos-relative center p-t-2 p-b-2">
                    <div class="w-11 z--1 pos-absolute top-50 left-50 bg-col-52"
                         style="height: 1px;transform: translate(-50%, -50%)"></div>
                    <span class="bg-col-4 p-l-2 p-r-2 col-43 p2">or</span>
                </div>
            </div>
            <!-- step 1 : account -->
            <checkout-step [name]="EStepName.account"
                           [stepTitle]="'Email'"
                           [order]="10">

                <div class="bg-col-w p-t-6 p-r-6 p-l-6 p-b-2 m-b"
                     zippyName="customerTab">
                    <!-- login form -->
                    <!-- customer -->
                    <!-- 'customer' tab header -->
                    @if (currentStepIndex !== 0) {
                    <div class="cursor-pointer"
                         (click)="goToStep(EStepName.account)">
                        <h4 class="s1 flex flex-middle"><i class="icon-account fs-7 inline-flex"></i>
                            <span class="p-l-3"
                                  style="padding-top: 2px;">{{'Contact' | translate}}</span>
                        </h4>
                        <div class="flex flex-justify-between m-t-1 p-l-9"
                             style="margin-left: 2px;">
                            <p class="p2 col-12 truncate p-r">
                                {{email}}
                            </p>
                            <button type="button"
                                    class="flex flex-middle p2 col-1 m-r-2">
                                <span [zippyName]="['customerTab','customer']"
                                      class="ng-hide"
                                      zippyClass="!ng-hide">{{'Hide' | translate}}</span>
                                <span [zippyName]="['customerTab','customer']"
                                      zippyClass="ng-hide"
                                      (click)="goToStep(EStepName.account)">{{'Change' | translate}}</span>
                                <i [zippyName]="['customerTab','customer']"
                                   zippyClass="is-open"
                                   class="p-l-3 fs-2 icon-arrow-down zippy-indicator"></i>
                            </button>
                        </div>
                    </div>
                    }

                    <!-- content: customer -->
                    <div [ngClass]="{'ng-hide-animate' : currentStepIndex !== 0}"
                         [zippyHideUp]="['customerTab','customer']"
                         [zippyAnimationDuration]="350"
                         [zippyOff]="currentStepIndex === 0">
                        <checkout-account [currentStepName]="currentStep?.name"
                                          [shipping]="data.address.shipping"
                                          class="block">
                        </checkout-account>
                    </div>
                </div>
            </checkout-step>
            @if (!isVirtual) {
            <checkout-step [name]="EStepName.delivery"
                           stepTitle="Delivery"
                           [order]="20">
                <div class="bg-col-w p-a-6 m-b">
                    <!-- delivery -->
                    <div zippyName="deliveryTab">
                        <!-- 'delivery' tab header -->
                        @if (currentStepIndex > 1) {
                        <div class="cursor-pointer"
                             [zippyToggle]="['deliveryTab','delivery']">
                            <div class="flex flex-top">
                                <i class="icon-address-book"
                                   [style.font-size.rem]="1.36"></i>
                                <div class="m-l-3 flex-grow inline-block">
                                    <span class="s1 p-t-1">{{'Delivery Address' | translate}}
                                    </span>
                                    <div class="flex flex-justify-between m-t-1">
                                        <span class="p2 col-12">
                                            {{data.address.shipping.firstname}}
                                            {{data.address.shipping.lastname}},
                                            {{data.address.shipping.street_1}},
                                            {{data.address.shipping.street_2}}
                                            {{data.address.shipping.city}},
                                            {{data.address.shipping.postcode}},
                                            {{data.address.shipping.country_id}}
                                        </span>
                                        <span class="flex flex-middle p2 col-1 m-r-2">
                                            <span [zippyName]="['deliveryTab','delivery']"
                                                  class="ng-hide"
                                                  zippyClass="!ng-hide">{{'Hide' | translate}}</span>
                                            <span [zippyName]="['deliveryTab','delivery']"
                                                  (click)="goToStep('delivery')"
                                                  zippyClass="ng-hide">{{'Change' | translate}}</span>
                                            <i [zippyName]="['deliveryTab','delivery']"
                                               zippyClass="is-open"
                                               class="p-l-3 fs-2 icon-arrow-down zippy-indicator"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        <!-- content: delivery -->
                        <div [ngClass]="{'ng-hide-animate' : currentStepIndex > 1}"
                             [zippyHideUp]="['deliveryTab','delivery']"
                             [zippyAnimationDuration]="350"
                             [zippyOff]="!(currentStepIndex > 1)">
                            <div class="p-b-6 center">
                                @if (currentStep?.name=== 'delivery') {
                                <div class="left flex flex-middle">
                                    <i class="icon-address-book"
                                       [style.font-size.rem]="1.36"></i>
                                    <p class="s1 m-l-3">{{'Delivery Address' | translate}}</p>
                                </div>
                                }
                                @if (hasCollectionMethods && selfCollect) {
                                <checkout-store-pickup [allMode]="true"></checkout-store-pickup>
                                }
                                @if (!selfCollect) {
                                <div>
                                    <!-- if storepickup is not an option -->
                                    <checkout-address class="w-12 m-t-3 left"
                                                      #shippingAddress
                                                      [data]="data.address.shipping">
                                    </checkout-address>
                                    <result class="w-12 m-t-2 m-t-4-s"
                                            duration="permanent"
                                            [status]="saveShippingAddressStatus"></result>
                                </div>
                                }
                                <div class="w-12 m-t-7">
                                    <button (click)="confirmDelivery()"
                                            class="button w-12"
                                            [class.disabled]="saveShippingAddressStatus.error"
                                            [class.busy]="saveShippingAddressStatus.busy || saveShippingMethodStatus.busy"
                                            [class.inactive]="!steps['delivery']?.valid">
                                        <span>{{'View Delivery Options' | translate}}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </checkout-step>
            <checkout-step [name]="EStepName.deliveryOptions"
                           stepTitle="Delivery Options"
                           [order]="25">
                <div class="bg-col-w p-a-6 m-b">
                    <!-- delivery -->
                    <div zippyName="deliveryOptionsTab">
                        <!-- 'delivery' tab header -->
                        @if (currentStepIndex > 2) {
                        <div class="cursor-pointer"
                             [zippyToggle]="['deliveryOptionsTab','deliveryOptions']">
                            <div class="flex flex-top">
                                <i class="icon-delivery"
                                   [style.font-size.rem]="1.36"></i>
                                <div class="m-l-3 flex-grow inline-block">
                                    <span class="s1 p-t-1">{{'Delivery Option' | translate}}
                                    </span>
                                    <div class="flex flex-justify-between m-t-1">
                                        <span class="p2 col-12">
                                            {{shippingMethod?.title}}
                                        </span>
                                        <span class="flex flex-middle p2 col-1 m-r-2">
                                            <span [zippyName]="['deliveryOptionsTab','deliveryOptions']"
                                                  class="ng-hide"
                                                  zippyClass="!ng-hide">{{'Hide' | translate}}</span>
                                            <span [zippyName]="['deliveryOptionsTab','deliveryOptions']"
                                                  (click)="goToStep('deliveryOptions')"
                                                  zippyClass="ng-hide">{{'Change' | translate}}</span>
                                            <i [zippyName]="['deliveryOptionsTab','deliveryOptions']"
                                               zippyClass="is-open"
                                               class="p-l-3 fs-2 icon-arrow-down zippy-indicator"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                        }
                        <!-- content: delivery options -->
                        <div [ngClass]="{'ng-hide-animate' : currentStepIndex > 2}"
                             [zippyHideUp]="['deliveryOptionsTab','deliveryOptions']"
                             [zippyAnimationDuration]="350"
                             [zippyOff]="!(currentStepIndex > 2)">
                            <div class="p-b-6 center">
                                @if (currentStep?.name=== 'deliveryOptions') {
                                <div class="left flex flex-middle">
                                    <i class="icon-delivery"
                                       [style.font-size.rem]="1.36"></i>
                                    <p class="s1 m-l-3">{{'Delivery Option' | translate}}</p>
                                </div>
                                }
                                @if (hasCollectionMethods && selfCollect) {
                                <checkout-store-pickup [allMode]="true"></checkout-store-pickup>
                                }
                                @if (!selfCollect) {
                                <div>
                                    <!-- delivery method -->
                                    <ng-container *ifTradeStore>
                                        @if (canShowBackorderNote) {
                                        <p class="ta-left p-t-2">{{backorderNode | translate}}
                                        </p>
                                        }
                                    </ng-container>
                                    <checkout-shipping-methods class="w-12"></checkout-shipping-methods>
                                </div>
                                }
                                <div class="w-12 m-t-5">
                                    <button (click)="confirmDeliveryOptions()"
                                            class="button w-12"
                                            [class.disabled]="saveShippingAddressStatus.error"
                                            [class.busy]="saveShippingAddressStatus.busy || saveShippingMethodStatus.busy"
                                            [class.inactive]="!steps['delivery']?.valid">
                                        <span>{{'Continue to payment' | translate}}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </checkout-step>
            }
            <!-- step 3 : payment -->
            <checkout-step [name]="EStepName.payment"
                           [stepTitle]="'Payment'"
                           [order]="30">
                <div class="bg-col-w p-a-6">

                    <!-- regular addresses -->
                    <div class="flex flex-top">
                        <i class="icon-lock fs-7"></i>
                        <span class="s1 m-l-3 p-t-1">{{'Secure payment' | translate}}</span>
                    </div>

                    <!-- payment -->
                    <checkout-payment-methods class="block m-t-4 left"></checkout-payment-methods>

                    <!-- billing address -->
                    <checkout-address class="w-12 m-t-4"
                                      [data]="data.address.billing"
                                      [isBilling]="true"></checkout-address>

                    <!-- mention me -->
                    <ng-container *ifNotStandalone>
                        <mention-me-wrapper *ifStore="'uk,us,ca,au'"
                                            class="block m-t"
                                            [mmid]="'mm8424c5bb'"
                                            [place]="MentionMePlace.refereefind"
                                            [situation]="'checkout'"
                                            [implementation]="'link'"></mention-me-wrapper>
                    </ng-container>

                    <!-- coupon form -->
                    <ng-container>
                        <coupon-form class="block m-t"></coupon-form>
                    </ng-container>

                    <!-- coupon form -->
                    <giftcards-form *ifNotTradeStore
                                    class="block m-t"></giftcards-form>
                </div>

                <!-- add donation-->
                @if (showDonation) {
                <checkout-add-donation></checkout-add-donation>
                }

                <div class="bg-col-w p-a-6">

                    <!-- totals -->
                    <div class="w-12 m-t-6">
                        <basket-view-totals [allowDiscountRemoval]="true"></basket-view-totals>
                    </div>

                    <div class="w-12 m-t-6">
                        <!-- place order -->
                        <div class="w-12"
                             [clickEvent]="submitClickEventName">
                            @if (paymentMethodCode !== 'braintree_paypal' && paymentMethodCode !==
                            'stripe_payments_prapi' && paymentMethodCode !== 'paypal_express' && paymentMethodCode !==
                            'stripe_payments_express') {
                            <action [status]="status"
                                    class="button w-12"
                                    (click)="submit()">
                                <span>{{'Place Order' | translate}}</span>
                            </action>
                            }
                        </div>
                        <div class="m-t"
                             [ngClass]="{'visually-hidden' : paymentMethodCode !== 'paypal_express'}">
                            <paypal-express-button></paypal-express-button>
                        </div>

                        <stripe-express-checkout class="m-t-9"
                                                 [ngClass]="{'visually-hidden' : paymentMethodCode !== 'stripe_payments_express'}"></stripe-express-checkout>

                        @if (paymentMethodByCode('braintree_paypal')) {
                        <braintree-paypal-checkout [ngClass]="paymentMethodCode !== 'braintree_paypal' ? 'no' : 'w-12'">
                        </braintree-paypal-checkout>
                        }

                        @if (paymentMethodByCode('stripe_payments_prapi')) {
                        <stripe-payment-request-button class="w-12"
                                                       [ngClass]="{'visually-hidden' : paymentMethodCode !== 'stripe_payments_prapi'}">
                        </stripe-payment-request-button>
                        }

                        <result class="w-12 m-t-2 center"
                                [status]="status"
                                [success]="'Data saved... redirecting...' | translate"></result>

                        <p class="p2 col-12 m-t center">
                            <span>{{'By placing your order you agree to our' | translate}}</span>&nbsp;
                            <a routerLink="/conditions-of-use"
                               target="_blank"
                               class="underline cursor-pointer">{{'Terms of Sale' | translate}}</a>.
                        </p>
                    </div>

                </div>
            </checkout-step>
            <!-- verification (iframe)  -->
            <checkout-confirmation [stepTitle]="'Confirmation'"
                                   [name]="EStepName.confirmation"
                                   [order]="999"></checkout-confirmation>
        </div>
        <!-- <div id="checkout-sticky-cutout"></div> -->
    </form>
</div>